import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { usePathname } from '@telialt/utils/src/pathname';

import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { getHomeUrl } from '../../utils/path';
import { LogoAnchor, LogoImage, LogoImageSmall } from './LogoItem.styles';

const LogoItem: FC<{ url?: string }> = ({ url: customUrl }) => {
    const { t } = useTranslations();
    const currentPath = usePathname();
    const homeUrl = getHomeUrl(currentPath, customUrl);

    return (
        <LogoAnchor
            href={homeUrl}
            data-test={NAVIGATION_TEST_IDS.LOGO}
            aria-label={t['navbar.logo_image.img_alt']}
            data-section="Other"
        >
            <LogoImage aria-hidden="true" />
            <LogoImageSmall aria-hidden="true" />
        </LogoAnchor>
    );
};
export { LogoItem };
